import gql from 'graphql-tag';

import { RosterIdentityBaseDetails } from '../fragments/roster-identity';

export const RosterIdentityHistory = gql`
  query rosterIdentityHistory(
    $roster_identity_ids: [RecordID]!
    $limit: Int = 20
    $offset: Int = 0
  ) {
    me {
      id
      roster_identities(
        slice: { limit: 1 }
        roster_identity_ids: $roster_identity_ids
      ) {
        records {
          id
          ...RosterIdentityBaseDetails
          purchased_custom_prints(slice: { limit: $limit, offset: $offset }) {
            total
            records {
              id
              created_at
              price {
                value
                currency
              }
              roster_identity_linked_identity_address {
                id
                address_line_1
              }
            }
          }
        }
      }
    }
  }
  ${RosterIdentityBaseDetails}
`;

export const RosterQrCodeForOnboarding = gql`
  query rosterQrCodeForOnboarding($roster_qr_code_id: RecordID!) {
    rosterQrCodeForOnboarding(roster_qr_code_id: $roster_qr_code_id) {
      album {
        id
        root_album_folder {
          id
        }
      }
      album_folder {
        id
      }
      accounts {
        id
        email_addresses
        phone_number
        type
      }
    }
  }
`;

export const RosterIdentityPurchasedCustomPrintPhotos = gql`
  query rosterIdentityPurchasedCustomPrintPhotos(
    $roster_identity_ids: [RecordID]!
  ) {
    me {
      id
      roster_identities(
        slice: { limit: 1 }
        roster_identity_ids: $roster_identity_ids
      ) {
        records {
          id
          photos {
            purchased_custom_print_photos(slice: { limit: 999 }) {
              records {
                id
              }
            }
          }
        }
      }
    }
  }
`;
